module.exports = __webpack_public_path__ + "media/images/ai_result-bg-7ed7c94a.jpeg";